import { AnimatePresence } from "framer-motion";
import { ElementType } from "react";

export const AnimatePresenceFixedType = AnimatePresence as ElementType;
